import { render } from "./List.vue?vue&type=template&id=247a705b"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=247a705b&lang=scss"
script.render = render

export default script